import React from "react";

const FormField = ({ label, type, name, placeholder, required }) => {
  return (
    <div className="form-field-container ">
      <label htmlFor={name}>{label}</label>
      {/* TODO: Make these required */}
      <input required name={name} type={type} placeholder={placeholder} />
    </div>
  );
};

export default FormField;
